import { Box, Button, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

export default function HeaderAnalytics({ activeTab, handleTabChange }) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <IconButton
          className="contained"
          onClick={() => navigate("/dashboard")}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h3" sx={{ ml: 2 }}>
          Analytics
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 0.7,
          backgroundColor: "#f5f5f5",
          padding: 0.7,
          borderRadius: 1,
          height: 30,
          "& > .MuiButton-root": {
            borderRadius: 0.7,
          },
        }}
      >
        <Button
          variant={activeTab === "menus" ? "contained" : "outlined"}
          onClick={() => handleTabChange("menus")}
          className={activeTab === "menus" ? "" : "inactive"}
        >
          Menus
        </Button>
        <Button
          variant={activeTab === "categories" ? "contained" : "outlined"}
          onClick={() => handleTabChange("categories")}
          className={activeTab === "categories" ? "" : "inactive"}
        >
          Categories
        </Button>
        <Button
          variant={activeTab === "items" ? "contained" : "outlined"}
          onClick={() => handleTabChange("items")}
          className={activeTab === "items" ? "" : "inactive"}
        >
          Items
        </Button>
      </Box>
    </Box>
  );
}
